/**
 * Check if all the words in a phrase match the given haystack
 * @param {String} haystack  The subject to search against
 * @param {String[]} searchWords  The phrase split into words
 * @returns {Boolean}
 */
export default function matchesAllWords(haystack, searchWords) {
	if (!Array.isArray(searchWords) || searchWords.length === 0 || typeof haystack !== 'string' || haystack.length === 0) {
		return false;
	}
	let lastLength = haystack.length;
	for (let word of searchWords) {
		word = word.toLocaleLowerCase();
		haystack = haystack.toLocaleLowerCase().replace(word, '');
		if (haystack.length === lastLength) {
			return false;
		}
		lastLength = haystack.length;
	}
	return true;
}

/**
 * Split a phrase string into a word array
 * @param {String} phrase  The search phrase
 * @returns {String[]}
 */
export function splitIntoWords(phrase) {
	return String(phrase).trim().split(/\s+/);
}

/**
 * Filter an array of objects using a search phrase against the given properties
 * @param {Object[]} objects  The records to filter
 * @param {String} phrase  The search phrase
 * @param {String[]} properties  An array of property names to search on each object
 * @param {Number} maxResults  The max number of results to return
 * @returns {Object[]}
 */
export function filterObjects(objects, phrase, properties, maxResults = Infinity) {
	if (
		!Array.isArray(objects) ||
		objects.length === 0 ||
		typeof phrase !== 'string' ||
		phrase.length === 0 ||
		!Array.isArray(properties) ||
		properties.length === 0 ||
		maxResults === 0
	) {
		return [];
	}
	const words = splitIntoWords(phrase.toLocaleLowerCase());
	const filtered = [];
	for (const object of objects) {
		if (typeof object !== 'object' || object === null) {
			continue;
		}
		for (const prop of properties) {
			if (object[prop] && matchesAllWords(String(object[prop]).toLocaleLowerCase(), words)) {
				filtered.push(object);
				break;
			}
		}
		if (filtered.length >= maxResults) {
			break;
		}
	}
	return filtered;
}
